import { Checkbox } from '../ui/Checkbox';
import { cn } from '../../lib/utils';

// ----------------------------------------------------------------------

interface TableSelectedActionProps {
  dense?: boolean;
  action?: React.ReactNode;
  rowCount?: number;
  numSelected: number;
  onSelectAllRows?: (checked: boolean) => void;
}

export default function TableSelectedAction({
  dense,
  action,
  rowCount = 0,
  numSelected,
  onSelectAllRows
}: TableSelectedActionProps) {
  if (numSelected === 0) {
    return null;
  }

  return (
    <div
      className={cn(
        'absolute left-0 right-0 z-10 flex items-center gap-4 bg-primary px-4 text-primary-foreground',
        dense ? 'h-10' : 'h-14'
      )}
    >
      {onSelectAllRows && (
        <Checkbox
          checked={rowCount > 0 && numSelected === rowCount}
          onCheckedChange={(checked) => onSelectAllRows(checked as boolean)}
          className="border-primary-foreground data-[state=checked]:bg-primary-foreground data-[state=checked]:text-primary dark:text-secondary"
        />
      )}

      <span className="text-sm font-medium">{numSelected} selected</span>

      <div className="flex-1" />

      {action}
    </div>
  );
}
